<div class="flex-container">
  <div class="flex-row header" style="align-items: center; gap: 12px">
    <span>{{ "PaymentDetail.texto" | translate }}</span>
    <div style="margin-left: auto; display: flex; gap: 6px">
      <span style="font-size: 12px; align-self: center; opacity: 0.6"
        >{{ "SwitchLanguage.texto" | translate }}:</span
      >
      <button
        (click)="switchLanguage('es')"
        [disabled]="translate.currentLang === 'es'"
      >
        {{ "Spanish.texto" | translate }}
      </button>
      <button
        (click)="switchLanguage('en')"
        [disabled]="translate.currentLang === 'en'"
      >
        {{ "English.texto" | translate }}
      </button>
    </div>
  </div>

  <div class="flex-column">
    <span class="input-header">{{ "FullName.texto" | translate }}</span>
    <span class="input">{{
      userFullName ||
        paymentOrder?.customerName ||
        ("UnknownUser.texto" | translate)
    }}</span>
  </div>

  <div class="flex-column">
    <span class="input-header">{{
      "ServiceDescription.texto" | translate
    }}</span>
    <span class="input">{{
      paymentOrder?.description ||
        ("ServiceDescriptionFallback.texto" | translate)
    }}</span>
  </div>
  <div class="flex-row">
    <div class="flex-column">
      <span class="input-header">{{ "ServicePrice.texto" | translate }}</span>
      <span class="input">{{
        displayUnitPrice === null
          ? "--"
          : (displayUnitPrice | number: "1.2-2") + " " + selectedCurrency
      }}</span>
    </div>
    <div class="flex-column">
      <span class="input-header">{{ "Total.texto" | translate }}</span>
      <span class="input">{{
        displayTotal === null
          ? "--"
          : (displayTotal | number: "1.2-2") + " " + selectedCurrency
      }}</span>
    </div>
  </div>
  <div class="flex-row specific">
    <div class="flex-column">
      <span class="input-header">{{ "PaymentMethod.texto" | translate }}</span>
      <span style="color: gray">{{
        "SelectPaymentMethod.texto" | translate
      }}</span>
    </div>
    <div class="flex-column">
      <mat-form-field
        class="width-100"
        [ngClass]="{ 'no-arrow': !multiCurrency }"
      >
        <mat-label
          >{{ "Currency.texto" | translate }}
          <span class="required-star" *ngIf="multiCurrency">*</span></mat-label
        >
        <mat-select
          style="padding-bottom: 0px !important"
          [(value)]="selectedCurrency"
          (selectionChange)="changeCurrency(true)"
          [disabled]="!multiCurrency || currencyChangeInFlight"
          [hideSingleSelectionIndicator]="!multiCurrency"
        >
          <mat-option value="USD">USD</mat-option>
          <mat-option value="VES">VES</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>

  <!-- Exchange rate could not be loaded: amounts are unknown, so payment is blocked -->
  <div
    class="no-data"
    *ngIf="rateUnavailable && !currencyChangeInFlight && !mostrarSpinner"
    style="margin: 1rem 0; text-align: center; color: #b00020"
  >
    {{ "ExchangeRateUnavailable.texto" | translate }}
  </div>

  <!-- BOTONES -->
  <div class="flex-row flex-button-pay margin-2rem">
    <button
      class="button-select button-mobile"
      [ngClass]="{ 'btn-active': method == 'credit' && checkStripe }"
      (click)="changeMethod('credit')"
      [disabled]="!checkStripe || rateUnavailable || currencyChangeInFlight"
      *ngIf="selectedCurrency == 'USD' && checkStripe"
    >
      <mat-icon>credit_card</mat-icon>
      <span
        class="select-menu ml-5"
        [ngClass]="{ 'btn-active': method == 'credit' }"
      >
        {{ "CreditCard.texto" | translate }}
      </span>
    </button>

    <button
      class="button-select button-mobile"
      [ngClass]="{ 'btn-active': method == 'customsvg' }"
      (click)="changeMethod('customsvg')"
      [disabled]="rateUnavailable || currencyChangeInFlight"
      *ngIf="selectedCurrency == 'VES' && showMercantilButton"
    >
      <span
        class="custom-svg-icon"
        style="
          display: flex;
          align-items: center;
          justify-content: center;
          height: 24px;
          width: 24px;
        "
      >
        <img
          src="/icons/Union.svg"
          alt="Pago Mercantil"
          width="24"
          height="24"
          style="object-fit: contain"
          class="svg-icon"
        />
      </span>
      <span
        class="select-menu ml-5"
        [ngClass]="{ 'btn-active': method == 'customsvg' }"
      >
        {{ "InmediatePayment.texto" | translate }}
      </span>
    </button>

    <button
      class="button-select button-mobile"
      [ngClass]="{ 'btn-active': method == 'pagomovil' }"
      (click)="changeMethod('pagomovil')"
      [disabled]="rateUnavailable || currencyChangeInFlight"
      *ngIf="selectedCurrency == 'VES' && checkPagomovil && typeOfBank != ''"
    >
      <mat-icon>phone_iphone</mat-icon>
      <span
        class="select-menu ml-5"
        [ngClass]="{ 'btn-active': method == 'pagomovil' }"
      >
        {{ "C2P.texto" | translate }}
      </span>
    </button>

    <button
      class="button-select button-mobile"
      [ngClass]="{ 'btn-active': method == 'bank' && checkTransfer }"
      [disabled]="!checkTransfer || rateUnavailable || currencyChangeInFlight"
      (click)="changeMethod('bank')"
      *ngIf="checkTransfer"
    >
      <mat-icon>sync_alt</mat-icon>
      <span [ngClass]="'btn-active'" class="select-menu ml-5">
        {{ "TransferOrDeposit.texto" | translate }}
      </span>
    </button>
    <!-- Información para Pago Mercantil -->
    <div
      *ngIf="method == 'customsvg'"
      class="info-mercantil"
      style="
        margin: 1rem 0;
        color: #333;
        background: #f5f5f5;
        padding: 1rem;
        text-align: justify;
        border-radius: 8px;
      "
    >
      {{ "MercantilTextBegin.texto" | translate }}
      <span style="font-weight: 900">{{
        "MercantilTextBold.texto" | translate
      }}</span>
      {{ "MercantilTextEnd.texto" | translate }}
    </div>
  </div>

  <!-- Message when no core payment methods are available (Stripe, Transfer/Deposit, C2P) -->
  <div
    class="no-data"
    *ngIf="
      !checkStripe && !checkTransfer && !checkPagomovil && !showMercantilButton
    "
    style="margin: 1rem 0; text-align: center"
  >
    {{ "NoPaymentMethodsAvailableContactAdmin.texto" | translate }}
  </div>
  <!-- Transfer Method Section -->
  <div *ngIf="method == 'bank'" class="flex-column" style="margin-top: 2rem">
    <span class="input-header" style="font-size: 1.1rem; margin-bottom: 1rem">{{
      "AssociatedAccountsForPayment.texto" | translate
    }}</span>
    <div class="scroll-div-bank width-lista-bancos">
      <div
        class="flex-service margin-2rem width-lista-bancos"
        *ngIf="dataBank.length > 0"
      >
        <div class="flex-service" *ngFor="let item of dataBank">
          <div class="flex-service-row" style="gap: 1rem">
            <div class="flex-service">
              <label>{{ "BankName.texto" | translate }}</label>
              <input
                type="text"
                class="input-mid"
                [value]="item.bankName"
                disabled
                style="border: none !important"
              />
            </div>

            <div class="flex-service">
              <label>{{ "BankData.texto" | translate }}</label>
              <textarea
                class="input-text-full"
                [value]="item.accountData"
                disabled
                style="border: none !important; text-indent: 0px"
                rows="3"
              ></textarea>
            </div>
          </div>
          <mat-divider
            style="margin-top: 1rem; margin-bottom: 1rem"
          ></mat-divider>
        </div>
      </div>
    </div>

    <span class="input-header" style="font-size: 1.1rem; margin-bottom: 1rem">{{
      "RegisterData.texto" | translate
    }}</span>
    <div class="flex-row bank-info-sync" [formGroup]="formPaymenBank">
      <div class="flex-column">
        <span class="input-header"
          >{{ "ReferenceNumber.texto" | translate }}
          <span class="required-star">*</span></span
        >
        <input
          type="text"
          class="input-full-none"
          placeholder="{{ '123456789' }}"
          formControlName="numberReference"
          minlength="10"
          maxlength="15"
          pattern="[A-Za-z0-9]{10,15}"
        />
      </div>
      <div class="flex-column">
        <span class="input-header"
          >{{ "ReceivingBankName.texto" | translate }}
          <span class="required-star">*</span></span
        >
        <mat-select
          class="input-full-none"
          formControlName="BankName"
          placeholder="{{ 'ReceivingBankName.texto' | translate }}"
        >
          <mat-option *ngFor="let bank of bankName" [value]="bank.name">
            {{ bank.name }}
          </mat-option>
        </mat-select>
      </div>
    </div>
    <div
      class="flex-row bank-info-sync"
      style="margin-top: 1rem"
      [formGroup]="formPaymenBank"
    >
      <div class="flex-column">
        <span class="input-header"
          >{{ "AccountHolder.texto" | translate }}
          <span class="required-star">*</span></span
        >
        <input
          type="text"
          class="input-full-none"
          placeholder="{{ 'AccountHolder.texto' | translate }}"
          formControlName="accountHolder"
        />
      </div>
      <div class="flex-column">
        <span class="input-header"
          >{{ "TransferDate.texto" | translate }}
          <span class="required-star">*</span></span
        >
        <mat-form-field
          appearance="outline"
          class="input-full-none datepicker-field"
        >
          <input
            matInput
            [matDatepicker]="picker"
            [max]="maxDate"
            formControlName="dateComplet"
            placeholder="dd/mm/yyyy"
            readonly
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="picker"
          ></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>
      </div>
    </div>
    <div class="flex-column margin-2rem">
      <span
        class="input-header"
        style="font-size: 1.1rem; margin-bottom: 1rem"
        >{{ "AttachPaymentReceipt.texto" | translate }}</span
      >
      <div class="flex-row" style="gap: 1rem; min-width: 100%">
        <!-- div con el input -->
        <div class="flex-column">
          <div class="file-container">
            <div class="inside-input">
              <mat-icon>cloud_upload</mat-icon>
              <label class="label-top">{{
                "DragTheFileHere.texto" | translate
              }}</label>
            </div>
            <input
              (change)="getFile($event)"
              class="file-input"
              type="file"
              id="myfile"
              accept=".pdf,.jpg,.png"
              #fileSelect
            />
          </div>
        </div>
        <div class="flex-column">
          <span style="font-size: 11px"
            >{{ "AllowedFileFormat.texto" | translate }}
            <br />
            {{ "MaximumFile.texto" | translate }}
          </span>
          <button class="button-file" (click)="fileSelect.click()">
            <mat-icon>upload</mat-icon>
            {{ "FileUpload.texto" | translate }}
          </button>
        </div>
      </div>
      <!-- div con el nombre del archivo -->
      <div *ngIf="showfile" class="flex-filename">
        <span style="padding-right: 1rem">
          {{ "FileName.texto" | translate }} {{ file.name }}</span
        >
        <mat-icon
          title="{{ deleteFileString }}"
          class="material-symbols-outlined"
          (click)="deleteFile()"
          style="cursor: pointer"
          >delete</mat-icon
        >
      </div>
    </div>
  </div>

  <!-- PAGO MOVIL -->
  <div class="flex-column pagomovil-section" *ngIf="method == 'pagomovil'">
    <!-- Bancos disponibles / detalles -->
    <div style="width: 100%" *ngIf="typeOfBank != ''">
      <label>{{ "PaymentDetail.texto" | translate }}</label>

      <div
        class="flex-row gap-1rem flex-direction-col"
        style="margin-top: 1rem"
      >
        <!-- Selección de banco -->
        <div class="flex-column">
          <label>
            {{ "SelectBank.texto" | translate }}
            <span class="required-star">*</span>
          </label>
          <mat-form-field appearance="fill" class="width-100">
            <mat-label>{{ "Select.texto" | translate }}</mat-label>
            <mat-select [(value)]="bankSelected">
              <mat-option
                *ngFor="let bank of listOfBanks"
                [value]="bank.codBanco"
              >
                {{ bank.nombreBanco }} - ({{ bank.codBanco }})
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <!-- Teléfono -->
        <div class="flex-column">
          <label>
            {{ "PhoneNumber.texto" | translate }}
            <span class="required-star">*</span>
          </label>
          <div class="flex-row gap-1rem">
            <mat-form-field class="width-prefix number-code" appearance="fill">
              <mat-label>{{ "PhonePrefix.texto" | translate }}</mat-label>
              <mat-select [(ngModel)]="prefixPhoneNumber" name="phonePrefix">
                <mat-option value="58412">0412</mat-option>
                <mat-option value="58422">0422</mat-option>
                <mat-option value="58414">0414</mat-option>
                <mat-option value="58424">0424</mat-option>
                <mat-option value="58416">0416</mat-option>
                <mat-option value="58426">0426</mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field class="width-100" appearance="fill">
              <mat-label>{{ "EnterPhoneNumber.texto" | translate }}</mat-label>
              <input
                matInput
                [(ngModel)]="phoneNumber"
                type="text"
                maxlength="7"
              />
              <mat-icon matSuffix>mode_edit</mat-icon>
            </mat-form-field>
          </div>
        </div>
      </div>

      <div class="flex-row gap-1rem flex-direction-col">
        <!-- Documento de identificación -->
        <div class="flex-column">
          <div class="flex-row">
            <label
              >{{ "DocumentFrom.texto" | translate }}
              <span class="required-star">*</span>
            </label>
          </div>

          <div class="flex-row gap-1rem">
            <mat-form-field
              class="width-prefix national-code"
              appearance="fill"
            >
              <mat-label>{{ "DocumentType.texto" | translate }}</mat-label>
              <mat-select [(ngModel)]="PrefixDni" name="documentPrefix">
                <mat-option value="V">V</mat-option>
                <mat-option value="E">E</mat-option>
                <mat-option value="P">P</mat-option>
                <mat-option value="C">C</mat-option>
                <mat-option value="J">J</mat-option>
                <mat-option value="G">G</mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field class="width-100" appearance="fill">
              <mat-label>{{ "DocumentNumber.texto" | translate }}</mat-label>
              <input matInput [(ngModel)]="dni" type="text" maxlength="16" />
              <mat-icon matSuffix>mode_edit</mat-icon>
            </mat-form-field>
          </div>

          <label
            class="font-10px"
            *ngIf="!(PrefixDni == 'V' || PrefixDni == 'E')"
          >
            {{ "RifDocument.texto" | translate }}
          </label>
          <label class="font-10px" *ngIf="PrefixDni == 'V' || PrefixDni == 'E'">
            {{ "Dniwithoutdots.texto" | translate }}
          </label>
        </div>

        <!-- Monto -->
        <div class="flex-column" style="margin-top: -58px">
          <label>{{ "AmountToCancel.texto" | translate }}</label>
          <span class="input-full span-flex">
            {{ getConvertedTotal() | number }} {{ accountCurrency.isoCode }}
          </span>
        </div>
      </div>

      <!-- OTP -->
      <div class="flex-column margin-top-1rem otp-mobile">
        <label style="margin-bottom: 0 !important"
          >{{ "Otp.texto" | translate }}
          <span class="required-star">*</span></label
        >
        <div class="flex-row gap-1rem align-center flex-direction-col">
          <mat-form-field class="width-50" appearance="fill">
            <mat-label>{{ "EnterCodeOtp.texto" | translate }}</mat-label>
            <input matInput [(ngModel)]="Otp" maxlength="8" />
            <mat-icon matSuffix>mode_edit</mat-icon>
          </mat-form-field>

          <a
            class="width-49"
            href="https://www.myservy.com/en/otp"
            target="_blank"
          >
            {{ "DynamicPassword.texto" | translate }}
          </a>
        </div>
      </div>
    </div>

    <!-- Si no hay typeOfBank disponible mostrar mensaje -->
    <div *ngIf="typeOfBank == ''" class="no-data">
      <span>{{ "Nopaymentoptionsareavailable.texto" | translate }}</span>
    </div>
  </div>
  <div
    class="content-info-card"
    *ngIf="
      method == 'credit' && accountCurrency.isoCode == 'USD' && checkStripe
    "
  >
    <mat-icon style="padding: 8px">error</mat-icon>
    <span>{{ "CreditCardPaymentsForAmountsLess.texto" | translate }}</span>
  </div>
  <div class="flex-column" *ngIf="method == 'credit'">
    <div class="stripe-card-wrapper">
      <div *ngIf="!stripeReady" class="stripe-loading">
        {{ "InitializingCard.texto" | translate }}
      </div>
      <ngx-stripe-card
        [elementsOptions]="elementsOptions"
        class="form-control stripe-card"
      ></ngx-stripe-card>
      <!-- Stripe error display: show decline code and translated message when present -->
      <div
        *ngIf="stripeErrorCode || stripeErrorMessage"
        class="stripe-error-block"
      >
        <div class="stripe-error-content">
          <div *ngIf="stripeErrorCode" class="stripe-error-code">
            {{ stripeErrorCode }}
          </div>
          <div *ngIf="stripeErrorMessage" class="stripe-error-message">
            {{ stripeErrorMessage }}
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Action Button: Render always for visibility, but disable unless a method is selected
       This avoids the button disappearing in transient states (currency change, async loads)
  -->
  <div
    class="pay-action-container"
    *ngIf="
      method == 'credit' ||
      method == 'bank' ||
      method == 'pagomovil' ||
      method == 'customsvg' ||
      method == 'cash' ||
      method == 'paypal'
    "
  >
    <button
      class="pay-action-button"
      (click)="onPayClick($event)"
      [disabled]="rateUnavailable || currencyChangeInFlight"
      title="{{ !method ? ('SelectPaymentMethod.texto' | translate) : '' }}"
    >
      {{ "MakePayment.texto" | translate }}
    </button>
  </div>
</div>

<div *ngIf="mostrarSpinner" class="spinner-overlay">
  <mat-spinner diameter="60"></mat-spinner>
</div>
